module.exports = new __parcel__URL__("login_divider.81de945b.png").toString();